import { create } from 'zustand';

interface DemoPlayerState {
  openId: string | null;
  openDemo: (id: string) => void;
  close: () => void;
}

export const useDemoPlayer = create<DemoPlayerState>((set) => ({
  openId: null,
  openDemo: (id) => set({ openId: id }),
  close: () => set({ openId: null }),
}));
